import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyEagleMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#e8f0ff" />
      <path d="M120 380 L397 200 L674 380 L620 420 L397 300 L174 420 Z" fill="#c49a6c" />
      <g className="mode-copy" transform="translate(48,840)" fill="#012"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyEagleMode;
